import React from 'react';
import { ModuleItemInterface } from '../../../types/home.type';

interface SpaceSectionProps {
  module: ModuleItemInterface;
}

const SpaceSection: React.FC<SpaceSectionProps> = ({ module }) => {
  return <div className="space-section" style={{ height: module.height || 20, backgroundColor: module.backgroundColor || 'transparent' }} />;
};

export default SpaceSection;
